import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowDown, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ToastrModule } from 'ngx-toastr';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { AppRoutingModule } from './app-routing.module';
import { ArianeComponent } from './components/ariane/ariane.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeadComponent } from './components/head/head.component';
import { HomeComponent } from './components/home/home.component';
import { MenuComponent } from './components/menu/menu.component';
import { PolicyComponent } from './components/policy/policy.component';
import { ESignatureErrorHandler } from './handlers/esignature-error-handler';
import { XsrfInterceptor } from './Interceptors/xsrf.interceptor';
import { VerificationModule } from './modules/verification/verification.module';
import { SignatureModule } from './modules/signature/signature.module';
import { CommonModule, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { LegalNoticeComponent } from './components/legal-notice/legal-notice.component';
import { CguComponent } from './components/cgu/cgu.component';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './components/app/app.component';
import { AppRedirectionService } from './guards/app.redirection.service';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from './modules/shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatButtonModule, MatMenuModule } from '@angular/material';
import { HomeBlockComponent } from './components/home-block/home-block.component';
import { SiteMapComponent } from './components/site-map/site-map.component';
import { AccessibilityComponent } from './components/accessibility/accessibility.component';
import { environment } from 'src/environments/environment';


export function HttpLoaderFactory(http: HttpClient) {
  const path = environment.envPath;
  return new TranslateHttpLoader(http, path + '/assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    HeadComponent,
    ArianeComponent,
    PolicyComponent,
    FooterComponent,
    DialogComponent,
    LegalNoticeComponent,
    CguComponent,
    HomeBlockComponent,
    SiteMapComponent,
    AccessibilityComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BreadcrumbModule,
    HttpClientModule,
    HttpClientXsrfModule,
    BrowserModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    ToastrModule.forRoot(),
    VerificationModule,
    SignatureModule,
    CommonModule,
    FormsModule,
    SharedModule,
    MatStepperModule,
    MatIconModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'fr',
      extend: true,
      loader: {
        provide: TranslateLoader,
        useFactory: (HttpLoaderFactory),
        deps: [HttpClient]
      }
    }),
    MatMenuModule,
    MatButtonModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: ESignatureErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfInterceptor, multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy
    },
    AppRedirectionService

  ],
  exports: [
    DialogComponent
  ],

  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faArrowRight, faArrowDown);
  }
}
